'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ToolboxSection = require('./ToolboxSection.scss');

var _ToolboxSection2 = _interopRequireDefault(_ToolboxSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToolboxSection = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ToolboxSection, _Component);

  function ToolboxSection() {
    (0, _classCallCheck3.default)(this, ToolboxSection);
    return (0, _possibleConstructorReturn3.default)(this, (ToolboxSection.__proto__ || (0, _getPrototypeOf2.default)(ToolboxSection)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolboxSection, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          header = _props.header;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, _ToolboxSection2.default.root) },
        (header || null) && _react2.default.createElement(
          'div',
          { className: _ToolboxSection2.default.header },
          header
        ),
        _react2.default.createElement(
          'div',
          { className: _ToolboxSection2.default.body },
          children
        )
      );
    }
  }]);
  return ToolboxSection;
}(_react.Component), _class.propTypes = {
  header: _react.PropTypes.node,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
}, _temp);
exports.default = ToolboxSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/ToolboxSection/ToolboxSection.jsx
// module id = 1564
// module chunks = 0